import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { getBasket, ApiBasket } from '../../api/basketService';
import { getBasketFromStorage } from '../../utils/local-storage-versioning';
import { queryRetry } from '../query-retry';

export const useGetBasketById = () => {
    const storedBasket = getBasketFromStorage();
    const basketId = storedBasket?.id;

    return useQuery<ApiBasket, AxiosError>({
        queryKey: ['basket', basketId],
        queryFn: () => getBasket(basketId as string),
        enabled: Boolean(basketId),
        refetchInterval: false,
        retry: queryRetry,
    });
};
